<script setup lang="ts">
/**
 * A still of the "Tailor to a job" panel (components/CV/Editor/TailorPanel.vue):
 * the match before and after, what the posting asks for, and one rewrite with
 * its checkbox. Shown on the homepage teaser and on /tailor-resume-to-job.
 * Illustration only — every word comes from `tailorPage.mock`.
 */
const { t } = useI18n()

const matching = ['react', 'typescript', 'agile'] as const
const missing = ['nextjs', 'testing'] as const
</script>

<template>
  <div class="rounded-[0.625rem] bg-white p-[1.875rem] shadow-lift dark:bg-gray-800" aria-hidden="true">
    <div class="flex items-baseline justify-between gap-4">
      <span class="font-title text-base font-bold text-ink dark:text-white">{{ t('tailorPage.mock.match') }}</span>
      <span class="font-title text-base font-bold text-muted line-through dark:text-gray-500">54 %</span>
    </div>
    <div class="mt-2 flex items-center gap-3">
      <div class="h-2 flex-1 overflow-hidden rounded-full bg-line dark:bg-gray-700">
        <div class="h-full w-[86%] rounded-full bg-accent" />
      </div>
      <span class="font-title text-2xl font-bold text-accent">86 %</span>
    </div>

    <div class="mt-5 flex flex-wrap gap-1.5">
      <span v-for="skill in matching" :key="skill" class="rounded-full bg-accent/10 px-3 py-1 text-sm font-medium text-accent">
        {{ t(`tailorPage.mock.skills.${skill}`) }}
      </span>
      <span v-for="skill in missing" :key="skill" class="rounded-full bg-red-50 px-3 py-1 text-sm font-medium text-red-700 dark:bg-red-900/30 dark:text-red-300">
        {{ t(`tailorPage.mock.skills.${skill}`) }}
      </span>
    </div>

    <div class="mt-6 flex items-start gap-3 rounded-[0.625rem] border border-line p-4 dark:border-gray-700">
      <i class="bi bi-check-square-fill mt-0.5 text-lg text-accent" />
      <div class="min-w-0">
        <div class="font-title text-sm font-bold text-ink dark:text-white">{{ t('tailorPage.mock.role') }}</div>
        <p class="mt-1 !text-sm text-muted line-through dark:text-gray-500">{{ t('tailorPage.mock.before') }}</p>
        <p class="mt-1 !text-sm text-body dark:text-gray-200">{{ t('tailorPage.mock.after') }}</p>
      </div>
    </div>

    <div class="mt-4 flex flex-wrap items-center gap-2">
      <span class="rounded-full border border-dashed border-line px-3 py-1 text-sm text-ink dark:border-gray-600 dark:text-white">+ {{ t('tailorPage.mock.skills.nextjs') }}</span>
      <span class="text-sm text-muted dark:text-gray-400">{{ t('tailorPage.mock.confirm') }}</span>
    </div>
  </div>
</template>
